/*
 * TreatmentList Messages
 *
 * This contains all the text for the TreatmentList component.
 */
import { defineMessages } from "react-intl";

export const scope = "app.components.TreatmentList";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the TreatmentList component!",
  },
  above: {
    id: `${scope}.above`,
    defaultMessage: "Above",
  },
  below: {
    id: `${scope}.below`,
    defaultMessage: "Below",
  },
  skipTreatment: {
    id: `${scope}.skipTreatment`,
    defaultMessage: "Skip treatment",
  },
  mustSelectEndProduct: {
    id: `${scope}.mustSelectEndProduct`,
    defaultMessage: "And end product must be selected",
  },
  editTreatment: {
    id: `${scope}.editTreatment`,
    defaultMessage: "Edit date",
  },
  cancelTreatment: {
    id: `${scope}.cancelTreatment`,
    defaultMessage: "Cancel treatment",
  },
  treatment: {
    id: `${scope}.treatment`,
    defaultMessage: "Treatment",
  },
  duration: {
    id: `${scope}.duration`,
    defaultMessage: "Duration",
  },
  tooSoonToEdit: {
    id: `${scope}.tooSoonToEdit`,
    defaultMessage: "You cannot edit an appointment planned within a week",
  },
  previous: {
    id: `${scope}.previous`,
    defaultMessage: "Previous",
  },
  cancelConfirmation: {
    id: `${scope}.cancelConfirmation`,
    defaultMessage: "Are you sure you want to cancel this treatment",
  },
  extraTreatmentConfirmation: {
    id: `${scope}.extraTreatmentConfirmation`,
    defaultMessage:
      "Door een extra behandeling in the plannen komt the eerstvolgende afspraak automatisch te vervallen. Je dient deze vervolgens opnieuw in te plannen na het maken van de extra afspraak. Weet je zeker dat je door wilt gaan?",
  },
  plannedDate: {
    id: `${scope}.plannedDate`,
    defaultMessage: "Planned date",
  },
  productUpperJaw: {
    id: `${scope}.productUpperJaw`,
    defaultMessage: "Product Upper jaw",
  },
  productLowerJaw: {
    id: `${scope}.productLowerJaw`,
    defaultMessage: "Product Lower jaw",
  },
  extraTreatment: {
    id: `${scope}.extraTreatment`,
    defaultMessage: "PLAN EXTRA TREATMENT WAGNER TRY-IN",
  },
  tooSoonPopUp: {
    id: `${scope}.tooSoonPopUp`,
    defaultMessage:
      "Je wilt een wijziging of annulering aanbrengen op een afspraak waarvan de planning al vaststaat. Neem telefonisch contact op met Refrezh zodat we gezamelijk voor een passende oplossing kunnen zorgen end de afspraak kunnen wijzigen of annuleren. Bel met ReFrezh: 088-700 5588",
  },
});
